function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.55 10.25C9.32457 10.25 9.10836 10.3396 8.94896 10.499C8.78955 10.6584 8.7 10.8746 8.7 11.1V20.45C8.7 20.6754 8.78955 20.8916 8.94896 21.051C9.10837 21.2104 9.32457 21.3 9.55 21.3H18.9C19.1254 21.3 19.3416 21.2104 19.501 21.051C19.6604 20.8916 19.75 20.6754 19.75 20.45V15.35C19.75 14.8806 20.1306 14.5 20.6 14.5C21.0694 14.5 21.45 14.8806 21.45 15.35V20.45C21.45 21.1263 21.1813 21.7749 20.7031 22.2531C20.2249 22.7313 19.5763 23 18.9 23H9.55C8.8737 23 8.2251 22.7313 7.74688 22.2531C7.26866 21.7749 7 21.1263 7 20.45V11.1C7 10.4237 7.26866 9.7751 7.74688 9.29688C8.2251 8.81866 8.8737 8.55 9.55 8.55H14.65C15.1194 8.55 15.5 8.93056 15.5 9.4C15.5 9.86944 15.1194 10.25 14.65 10.25H9.55Z",
  fill: "#BABAC8"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.2 6.85C17.2 6.38056 17.5806 6 18.05 6H23.15C23.6194 6 24 6.38056 24 6.85V11.95C24 12.4194 23.6194 12.8 23.15 12.8C22.6806 12.8 22.3 12.4194 22.3 11.95V7.7H18.05C17.5806 7.7 17.2 7.31944 17.2 6.85Z",
  fill: "#BABAC8"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.751 6.24896C24.083 6.5809 24.083 7.1191 23.751 7.45104L14.401 16.801C14.0691 17.133 13.5309 17.133 13.199 16.801C12.867 16.4691 12.867 15.9309 13.199 15.599L22.549 6.24896C22.8809 5.91701 23.4191 5.91701 23.751 6.24896Z",
  fill: "#BABAC8"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4 3C3.73478 3 3.48043 3.10536 3.29289 3.29289C3.10536 3.48043 3 3.73478 3 4V13C3 13.2652 3.10536 13.5196 3.29289 13.7071C3.48043 13.8946 3.73478 14 4 14H5C5.55228 14 6 14.4477 6 15C6 15.5523 5.55228 16 5 16H4C3.20435 16 2.44129 15.6839 1.87868 15.1213C1.31607 14.5587 1 13.7956 1 13V4C1 3.20435 1.31607 2.44129 1.87868 1.87868C2.44129 1.31607 3.20435 1 4 1H13C13.7956 1 14.5587 1.31607 15.1213 1.87868C15.6839 2.44129 16 3.20435 16 4V5C16 5.55228 15.5523 6 15 6C14.4477 6 14 5.55228 14 5V4C14 3.73478 13.8946 3.48043 13.7071 3.29289C13.5196 3.10536 13.2652 3 13 3H4Z",
  fill: "#BABAC8"
});

function SvgCopyToOther(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyToOther);
export default __webpack_public_path__ + "static/media/copy_to_other.b9a80936.svg";
export { ForwardRef as ReactComponent };